import {
  HTTP_GETMONTHBUDGET_FETCHING,
  HTTP_GETMONTHBUDGET_SUCCESS,
  HTTP_GETMONTHBUDGET_FAILED,
  HTTP_RESET_GETMONTHBUDGET,
  server,
  OK,
  YES,
} from "src/Constants";
import { httpClient } from "src/utils/HttpClient";

export const setStateGetMonthBudgetToFetching = () => ({
  type: HTTP_GETMONTHBUDGET_FETCHING,
});

export const setStateGetMonthBudgetToSuccess = (payload) => ({
  type: HTTP_GETMONTHBUDGET_SUCCESS,
  payload,
});

export const setStateGetMonthBudgetToFailed = (payload) => ({
  type: HTTP_GETMONTHBUDGET_FAILED,
});

export const clearMonthBudget = () => {
  return async (dispatch) => {
    dispatch(setStateGetMonthBudgetToSuccess([]));
  };
};

export const getMonthBudget = (year) => {
  return async (dispatch) => {
    dispatch(setStateGetMonthBudgetToFetching());
    try {
      const result = await httpClient.get(
        `${server.GETMONTHBUDGET_URL}/${year}`,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      dispatch(setStateGetMonthBudgetToSuccess(result.data));
      return Promise.resolve(result.data[0]);
    } catch (error) {
      dispatch(setStateGetMonthBudgetToFailed());
    }
  };
};
